import React, { Component } from "react";
import PlayTrackIcon from './../../../../images/playtrackicon.png'
import PauseIcon from './../../../../images/pauseicon.png'
import "./AudioBtn.css";

class AudioButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false
    };
    
  }

  onPlay = (event) => {
    this.setState({ playing: true });
    console.log("Playing")
  };
  onPause = (event) => {
    this.setState({ playing: false });
    console.log("Paused")
  };
  onEnded = (event) => {
    this.setState({ playing: false });
  };

  playAudio = () => {
    this.audioEl.play();
    const audio = this.audioEl;
    audio.addEventListener("play", this.onPlay);
    audio.addEventListener("pause", this.onPause);
  };

  pauseAudio = () => {
    this.audioEl.pause();
  };

  startAudio = () => {
    this.playAudio();
  };

  renderAudio = () => {
    const { url } = this.props;
    const { playing } = this.state;
    console.log(url)
    return (
      <div >
        {!playing && (
          <img src={PlayTrackIcon} className="btn" onClick={this.startAudio}/>
        )}
        {playing && <img src={PauseIcon} className="btn" onClick={this.pauseAudio}/>}

        <audio
          src={url}
          ref={(ref) => {
            this.audioEl = ref;
          }}
        />
         
       
      </div>
    );
  };

  render() {
    return this.renderAudio();
  }
}

export default AudioButton;
